import { createFileRoute } from "@tanstack/react-router";
import BcbswyInsurance, { config } from "@/pages/BcbswyInsurance";
import { buildInsuranceSchema } from "@/components/InsurancePageTemplate";
export const Route = createFileRoute("/bcbswy-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "BCBS Wyoming TMS Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Blue Cross Blue Shield Wyoming coverage for TMS, SAINT TMS, and SPRAVATO. Benefits verification in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:title",
          content: "BCBS Wyoming TMS Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Blue Cross Blue Shield Wyoming coverage for TMS, SAINT TMS, and SPRAVATO. Benefits verification in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/bcbswy-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/bcbswy-insurance",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(buildInsuranceSchema(config)),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <BcbswyInsurance />;
}
